import { render, staticRenderFns } from "./Target_retrieval.vue?vue&type=template&id=d5521404"
import script from "./Target_retrieval.vue?vue&type=script&lang=js"
export * from "./Target_retrieval.vue?vue&type=script&lang=js"
import style0 from "./Target_retrieval.vue?vue&type=style&index=0&id=d5521404&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports